export const categories = [
  { slug: 'remen', name: '热门推荐', icon: 'ri-fire-line' },
  { slug: 'zuixin', name: '最新上架', icon: 'ri-rocket-line' },
  { slug: 'wanjie', name: '完结漫画', icon: 'ri-check-double-line' },
  { slug: 'lianai', name: '恋爱漫画', icon: 'ri-heart-line' },
  { slug: 'qihuan', name: '奇幻冒险', icon: 'ri-magic-line' },
  { slug: 'dongzuo', name: '动作热血', icon: 'ri-flashlight-line' },
  { slug: 'xuanyi', name: '悬疑推理', icon: 'ri-mind-map' },
  { slug: 'dushi', name: '都市生活', icon: 'ri-building-line' },
];

export const comics = [
  {
    id: 1,
    title: '剑与魔法',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20fantasy%20sword%20and%20magic%20theme%2C%20male%20protagonist%20with%20dark%20hair%20holding%20glowing%20sword%2C%20mystical%20background%20with%20ancient%20ruins%2C%20dramatic%20lighting%2C%20clean%20composition%2C%20warm%20golden%20and%20dark%20tones%2C%20soft%20gradient%20background%2C%20professional%20illustration%20style&width=800&height=1200&seq=comic-cover-01&orientation=portrait',
    category: 'qihuan',
    status: '连载中',
    rating: 9.5,
    views: 1280000,
    description: '在一个被魔法与剑术统治的世界中，少年亚伦意外获得了传说中勇者的力量。面对黑暗势力的崛起，他必须集结伙伴，踏上拯救王国的史诗冒险之旅。',
    lastUpdated: '2026-07-08',
    chapters: [
      { num: 1, title: '命运的开始', updateDate: '2025-01-15', pageCount: 48 },
      { num: 2, title: '觉醒的力量', updateDate: '2025-01-22', pageCount: 52 },
      { num: 3, title: '黑暗降临', updateDate: '2025-01-29', pageCount: 45 },
      { num: 4, title: '伙伴集结', updateDate: '2025-02-05', pageCount: 50 },
      { num: 5, title: '试炼之路', updateDate: '2025-02-12', pageCount: 55 },
      { num: 6, title: '王城之影', updateDate: '2025-02-19', pageCount: 47 },
      { num: 7, title: '龙之咆哮', updateDate: '2025-02-26', pageCount: 60 },
      { num: 8, title: '最终决战', updateDate: '2025-03-05', pageCount: 65 },
    ],
  },
  {
    id: 2,
    title: '首尔恋歌',
    author: '朴智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20young%20couple%20in%20Seoul%20cityscape%2C%20cherry%20blossom%20petals%20falling%2C%20warm%20pink%20and%20soft%20pastel%20tones%2C%20clean%20minimalist%20background%2C%20delicate%20lineart%2C%20romantic%20atmosphere%2C%20professional%20illustration%20style&width=800&height=1200&seq=comic-cover-02&orientation=portrait',
    category: 'lianai',
    status: '连载中',
    rating: 9.2,
    views: 980000,
    description: '在繁华的首尔街头，两个截然不同的灵魂意外相遇。一个是追逐梦想的插画师，一个是冷峻的商业精英，他们的故事从一杯咖啡开始。',
    lastUpdated: '2026-07-06',
    chapters: [
      { num: 1, title: '偶然相遇', updateDate: '2025-03-10', pageCount: 42 },
      { num: 2, title: '咖啡与微笑', updateDate: '2025-03-17', pageCount: 38 },
      { num: 3, title: '雨天的约定', updateDate: '2025-03-24', pageCount: 45 },
      { num: 4, title: '心动瞬间', updateDate: '2025-03-31', pageCount: 40 },
      { num: 5, title: '误会与真心', updateDate: '2025-04-07', pageCount: 44 },
      { num: 6, title: '樱花下的告白', updateDate: '2025-04-14', pageCount: 50 },
    ],
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '李东旭',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20cover%2C%20detective%20silhouette%20in%20rainy%20night%20alley%2C%20neon%20reflections%20on%20wet%20pavement%2C%20dark%20moody%20atmosphere%2C%20deep%20blue%20and%20crimson%20highlights%2C%20clean%20composition%2C%20cinematic%20noir%20style%2C%20professional%20illustration&width=800&height=1200&seq=comic-cover-03&orientation=portrait',
    category: 'xuanyi',
    status: '已完结',
    rating: 9.7,
    views: 2100000,
    description: '首尔深夜，连环案件频发。天才侧写师韩俊昊与重案组刑警携手，揭开隐藏在都市霓虹下的惊人真相。每一步都步步惊心，真相远比想象更加残酷。',
    lastUpdated: '2026-06-20',
    chapters: [
      { num: 1, title: '第一案', updateDate: '2024-06-01', pageCount: 55 },
      { num: 2, title: '沉默的证人', updateDate: '2024-06-08', pageCount: 48 },
      { num: 3, title: '最后通牒', updateDate: '2024-06-15', pageCount: 52 },
      { num: 4, title: '追捕', updateDate: '2024-06-22', pageCount: 60 },
      { num: 5, title: '真相大白', updateDate: '2024-06-29', pageCount: 58 },
    ],
  },
  {
    id: 4,
    title: '热血格斗场',
    author: '崔志浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20martial%20arts%20fighter%20in%20dynamic%20pose%2C%20intense%20fighting%20scene%2C%20stadium%20background%20with%20spotlights%2C%20bold%20red%20and%20black%20color%20scheme%2C%20clean%20dramatic%20composition%2C%20powerful%20energy%2C%20professional%20illustration%20style&width=800&height=1200&seq=comic-cover-04&orientation=portrait',
    category: 'dongzuo',
    status: '连载中',
    rating: 9.0,
    views: 760000,
    description: '地下格斗场，一个以拳头说话的残酷世界。少年姜泰武为了寻找失散的妹妹，踏上了这条血与荣耀之路。每一场比赛都是生死较量。',
    lastUpdated: '2026-07-05',
    chapters: [
      { num: 1, title: '地下世界', updateDate: '2025-05-20', pageCount: 40 },
      { num: 2, title: '第一场战斗', updateDate: '2025-05-27', pageCount: 45 },
      { num: 3, title: '宿命的对手', updateDate: '2025-06-03', pageCount: 50 },
      { num: 4, title: '绝境反击', updateDate: '2025-06-10', pageCount: 55 },
    ],
  },
  {
    id: 5,
    title: '魔法学院',
    author: '尹智秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20academy%20manhwa%20cover%2C%20magic%20school%20students%20in%20uniforms%2C%20floating%20spell%20books%20and%20magical%20effects%2C%20%20grand%20castle%20school%20background%2C%20soft%20purple%20and%20gold%20magical%20glow%2C%20clean%20composition%2C%20whimsical%20atmosphere%2C%20professional%20illustration&width=800&height=1200&seq=comic-cover-05&orientation=portrait',
    category: 'qihuan',
    status: '已完结',
    rating: 9.3,
    views: 1500000,
    description: '平凡少女朴小星意外收到了魔法学院的录取通知书。在这个充满魔法与奇迹的校园里，她将发现自己的真实身份，揭开隐藏千年的秘密。',
    lastUpdated: '2026-05-15',
    chapters: [
      { num: 1, title: '猫头鹰来信', updateDate: '2024-09-01', pageCount: 42 },
      { num: 2, title: '初入学院', updateDate: '2024-09-08', pageCount: 48 },
      { num: 3, title: '魔法课', updateDate: '2024-09-15', pageCount: 44 },
      { num: 4, title: '地下迷宫', updateDate: '2024-09-22', pageCount: 52 },
      { num: 5, title: '真相', updateDate: '2024-09-29', pageCount: 56 },
    ],
  },
  {
    id: 6,
    title: '办公室罗曼史',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%2C%20elegant%20man%20and%20woman%20in%20modern%20office%20setting%2C%20warm%20sunlight%20through%20windows%2C%20professional%20attire%2C%20subtle%20romantic%20tension%2C%20soft%20beige%20and%20warm%20brown%20tones%2C%20clean%20composition%2C%20sophisticated%20illustration%20style&width=800&height=1200&seq=comic-cover-06&orientation=portrait',
    category: 'dushi',
    status: '连载中',
    rating: 8.9,
    views: 650000,
    description: '公司里最不对付的两个人，因为一个项目被迫成为搭档。从针锋相对到惺惺相惜，办公室的每一次擦肩而过都暗藏心动。',
    lastUpdated: '2026-07-07',
    chapters: [
      { num: 1, title: '新搭档', updateDate: '2025-08-10', pageCount: 38 },
      { num: 2, title: '加班夜', updateDate: '2025-08-17', pageCount: 42 },
      { num: 3, title: '团建风波', updateDate: '2025-08-24', pageCount: 40 },
    ],
  },
  {
    id: 7,
    title: '神之塔',
    author: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20epic%20fantasy%20manhwa%20cover%2C%20mysterious%20tower%20reaching%20into%20clouds%2C%20young%20adventurer%20climbing%2C%20magical%20artifacts%20floating%2C%20vast%20scale%2C%20deep%20rich%20colors%2C%20mythical%20atmosphere%2C%20clean%20heroic%20composition%2C%20professional%20illustration&width=800&height=1200&seq=comic-cover-07&orientation=portrait',
    category: 'qihuan',
    status: '连载中',
    rating: 9.8,
    views: 5000000,
    description: '只要登上塔顶，就能实现任何愿望。少年第二十五夜为了追寻唯一的伙伴，毅然踏上了这条充满未知与危险的登塔之路。',
    lastUpdated: '2026-07-08',
    chapters: [
      { num: 1, title: '塔之入口', updateDate: '2023-01-10', pageCount: 60 },
      { num: 2, title: '第一层考验', updateDate: '2023-01-17', pageCount: 55 },
      { num: 3, title: '守护者之战', updateDate: '2023-01-24', pageCount: 65 },
      { num: 4, title: '隐藏之层', updateDate: '2023-01-31', pageCount: 58 },
      { num: 5, title: '王冠游戏', updateDate: '2023-02-07', pageCount: 70 },
      { num: 6, title: '队伍分裂', updateDate: '2023-02-14', pageCount: 62 },
      { num: 7, title: '工房战', updateDate: '2023-02-21', pageCount: 68 },
      { num: 8, title: '最后的测试', updateDate: '2023-02-28', pageCount: 75 },
    ],
  },
  {
    id: 8,
    title: '甜蜜的谎言',
    author: '林娜恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20sweet%20romance%20manhwa%20cover%2C%20couple%20sharing%20earbuds%20in%20autumn%20park%2C%20golden%20leaves%20falling%2C%20warm%20cozy%20atmosphere%2C%20soft%20orange%20and%20cream%20tones%2C%20intimate%20moment%2C%20clean%20gentle%20composition%2C%20professional%20illustration%20style&width=800&height=1200&seq=comic-cover-08&orientation=portrait',
    category: 'lianai',
    status: '已完结',
    rating: 9.1,
    views: 890000,
    description: '为了逃避家族安排的婚姻，财阀千金假扮成普通上班族，却爱上了公司里最不起眼的程序员。当谎言被揭穿，爱情会走向何方？',
    lastUpdated: '2026-04-30',
    chapters: [
      { num: 1, title: '逃跑的新娘', updateDate: '2024-11-01', pageCount: 40 },
      { num: 2, title: '平凡的一天', updateDate: '2024-11-08', pageCount: 38 },
      { num: 3, title: '意外心动', updateDate: '2024-11-15', pageCount: 42 },
      { num: 4, title: '身份暴露', updateDate: '2024-11-22', pageCount: 45 },
      { num: 5, title: '真爱告白', updateDate: '2024-11-29', pageCount: 50 },
    ],
  },
  {
    id: 9,
    title: '丧尸校园',
    author: '朱东根',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20zombie%20survival%20manhwa%20cover%2C%20students%20barricaded%20in%20school%20classroom%2C%20tense%20atmosphere%2C%20broken%20windows%2C%20survival%20gear%2C%20dark%20gritty%20style%2C%20emergency%20red%20lighting%2C%20clean%20dramatic%20composition%2C%20professional%20illustration&width=800&height=1200&seq=comic-cover-09&orientation=portrait',
    category: 'dongzuo',
    status: '已完结',
    rating: 9.4,
    views: 3200000,
    description: '普通的一天，校园突然爆发丧尸病毒。被困在学校里的学生们必须在绝境中求生，友情与人性在末日面前展露无遗。',
    lastUpdated: '2026-03-10',
    chapters: [
      { num: 1, title: '爆发', updateDate: '2024-03-15', pageCount: 50 },
      { num: 2, title: '被困', updateDate: '2024-03-22', pageCount: 48 },
      { num: 3, title: '突围', updateDate: '2024-03-29', pageCount: 55 },
      { num: 4, title: '救援', updateDate: '2024-04-05', pageCount: 60 },
      { num: 5, title: '新生', updateDate: '2024-04-12', pageCount: 52 },
    ],
  },
  {
    id: 10,
    title: '永生之塔',
    author: '金明洙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20immortal%20fantasy%20manhwa%20cover%2C%20ancient%20immortal%20warrior%20in%20modern%20Seoul%2C%20traditional%20and%20modern%20elements%20blending%2C%20mystical%20energy%20swirling%2C%20dark%20blue%20and%20gold%20accents%2C%20clean%20epic%20composition%2C%20professional%20illustration&width=800&height=1200&seq=comic-cover-10&orientation=portrait',
    category: 'qihuan',
    status: '连载中',
    rating: 9.6,
    views: 1800000,
    description: '活了千年的不死武士，在现代首尔过着隐居生活。然而当古老的敌人重新出现，他不得不再次拿起武器，守护这个他深爱的世界。',
    lastUpdated: '2026-07-04',
    chapters: [
      { num: 1, title: '千年之约', updateDate: '2025-04-01', pageCount: 48 },
      { num: 2, title: '都市隐者', updateDate: '2025-04-08', pageCount: 45 },
      { num: 3, title: '远古回声', updateDate: '2025-04-15', pageCount: 52 },
      { num: 4, title: '宿敌现身', updateDate: '2025-04-22', pageCount: 55 },
      { num: 5, title: '决断之时', updateDate: '2025-04-29', pageCount: 50 },
    ],
  },
  {
    id: 11,
    title: '推理俱乐部',
    author: '朴敏英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20club%20manhwa%20cover%2C%20group%20of%20students%20investigating%20in%20library%2C%20magnifying%20glass%20and%20clues%20scattered%2C%20warm%20lamp%20light%2C%20cozy%20mystery%20atmosphere%2C%20brown%20and%20cream%20tones%2C%20clean%20composition%2C%20professional%20illustration&width=800&height=1200&seq=comic-cover-11&orientation=portrait',
    category: 'xuanyi',
    status: '连载中',
    rating: 8.8,
    views: 520000,
    description: '大学推理社团的五名成员，在课余时间调查校园内外各种神秘事件。每一个案件背后，都隐藏着令人意想不到的真相。',
    lastUpdated: '2026-07-03',
    chapters: [
      { num: 1, title: '社团招新', updateDate: '2025-06-10', pageCount: 38 },
      { num: 2, title: '消失的试卷', updateDate: '2025-06-17', pageCount: 42 },
      { num: 3, title: '图书馆幽灵', updateDate: '2025-06-24', pageCount: 45 },
    ],
  },
  {
    id: 12,
    title: '大明星的小秘密',
    author: '郑彩妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20celebrity%20romance%20manhwa%20cover%2C%20famous%20actor%20and%20ordinary%20girl%20meeting%20backstage%2C%20stage%20lights%20glowing%2C%20glamorous%20yet%20warm%20atmosphere%2C%20soft%20pink%20and%20champagne%20gold%20tones%2C%20clean%20romantic%20composition%2C%20professional%20illustration&width=800&height=1200&seq=comic-cover-12&orientation=portrait',
    category: 'dushi',
    status: '连载中',
    rating: 8.7,
    views: 710000,
    description: '顶级偶像崔时安有一个不为人知的秘密——他是个狂热的甜品爱好者。而这个秘密，被附近甜品店的老板娘发现了。',
    lastUpdated: '2026-07-06',
    chapters: [
      { num: 1, title: '秘密曝光', updateDate: '2025-07-15', pageCount: 36 },
      { num: 2, title: '甜品约会', updateDate: '2025-07-22', pageCount: 40 },
      { num: 3, title: '绯闻危机', updateDate: '2025-07-29', pageCount: 44 },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '王小明',
    role: '资深漫画爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Chinese%20man%2C%20warm%20friendly%20expression%2C%20casual%20style%2C%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20photography%2C%20soft%20shadows%2C%20high%20quality&width=400&height=400&seq=testimonial-01&orientation=squarish',
    content: '韩漫漫画网真是太棒了！画质高清，更新速度快，最重要的是完全免费。我已经推荐给了身边所有喜欢漫画的朋友，大家都说好用！',
  },
  {
    id: 2,
    name: '李美丽',
    role: '大学生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Chinese%20woman%2C%20gentle%20smile%2C%20natural%20look%2C%20soft%20daylight%20portrait%2C%20clean%20cream%20background%2C%20editorial%20photography%2C%20warm%20tones%2C%20high%20quality&width=400&height=400&seq=testimonial-02&orientation=squarish',
    content: '下拉式阅读体验太流畅了，躺在床上看漫画简直是享受。收藏的书架功能也很方便，可以随时继续上次看到的地方。',
  },
  {
    id: 3,
    name: '张大力',
    role: '程序员',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Chinese%20man%20with%20glasses%2C%20friendly%20expression%2C%20casual%20tech%20style%2C%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20photography%2C%20soft%20shadows%2C%20high%20quality&width=400&height=400&seq=testimonial-03&orientation=squarish',
    content: '下班后最大的放松就是来韩漫漫画网看漫画。分类清晰，找漫画很方便，而且每天都有更新，根本停不下来！',
  },
];

export const faqs = [
  {
    question: '韩漫漫画网上的漫画是否全部免费？',
    answer: '是的，韩漫漫画网上的所有漫画均为免费阅读。我们致力于为漫画爱好者提供高质量的免费韩漫阅读服务，无需任何付费即可畅享所有内容。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过首页顶部的搜索栏直接输入漫画名称进行搜索，也可以浏览各分类页面按类型筛选漫画。我们支持按热门推荐、最新上架、完结状态等多种方式浏览。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '连载中的漫画通常每周更新一到两话，具体更新频率取决于原作者和汉化组的进度。您可以在漫画详情页查看最新更新时间，热门漫画更新速度更快。',
  },
  {
    question: '支持在手机上阅读吗？',
    answer: '当然支持！韩漫漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。随时随地，打开浏览器即可享受流畅的下拉式阅读体验。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是韩漫特有的阅读方式，您只需向下滑动页面即可连续阅读，无需翻页。这种阅读方式专为手机优化，让阅读体验更加流畅自然。',
  },
  {
    question: '我可以下载漫画离线阅读吗？',
    answer: '目前我们仅支持在线下拉式阅读，暂不支持下载功能。我们建议您在有网络的环境下访问韩漫漫画网以获得最佳阅读体验。',
  },
];

export const platformStats = {
  totalComics: 12800,
  totalChapters: 356000,
  dailyVisitors: 520000,
  registeredUsers: 8900000,
  yearsActive: 6,
  updateFrequency: '每日更新',
};